import { OnboardEmergencyContactDetails } from './OnboardEmergencyContactDetails';
import { OnboardVrifications } from './OnboardVrifications';
import { OnboardEmpFamilyDetail } from './OnboardEmpFamilyDetail';

export class OnboardEmployeePersonalDetails {
  EmpId: number
  NoOfDependents: number;
  MaritalStatus: number;
  WeddingDate: Date;
  CreatedBy: string;
  CreatedDate: Date;
  ModifiedBy: string;
  ModifiedDate: Date;
  Father: OnboardEmpFamilyDetail = new OnboardEmpFamilyDetail();
  Mother: OnboardEmpFamilyDetail = new OnboardEmpFamilyDetail();
  Spouse: OnboardEmpFamilyDetail = new OnboardEmpFamilyDetail();
  children: OnboardEmpFamilyDetail[] = [];
  FamilyDetails: OnboardEmpFamilyDetail[] = [];
  emergencyContactDtls: OnboardEmergencyContactDetails[] = [];
  onboardVrifications: OnboardVrifications = new OnboardVrifications();
}
